(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowDefinitionSelector', drvWorkflowDefinitionSelector);

    drvWorkflowDefinitionSelector.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvWorkflowDefinitionSelector
     * @description Selector for choosing a workflow definition
     */
    function drvWorkflowDefinitionSelector() {
        var directive = {
            restrict: 'E',
            controller: WorkflowDefinitionSelectorCtrl,
            templateUrl: 'app/Workflow/workflow-definition-selector.tmpl.html',
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                workflowDefinitions: '<',
                searchText: '=?',
                selectedWorkflowDefinition: '=?',
            }
        };
        return directive;
    }

    function WorkflowDefinitionSelectorCtrl() {
        var vm = this;
    }
})();